import { Mail, Phone, MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { motion } from "framer-motion";

interface VerificationMethodSelectorProps {
  onSelectEmail: () => void;
  onSelectSMS: () => void;
  onSelectWhatsApp: () => void;
}

export const VerificationMethodSelector = ({
  onSelectEmail,
  onSelectSMS,
  onSelectWhatsApp,
}: VerificationMethodSelectorProps) => {
  return (
    <div className="space-y-6">
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        className="text-center space-y-2"
      >
        <h1 className="text-xl font-bold">Como prefere verificar?</h1>
        <p className="text-muted-foreground">
          Escolha o método de verificação
        </p>
      </motion.div>

      <div className="space-y-3">
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.1 }}
        >
          <Card 
            className="p-4 hover:border-primary transition-all cursor-pointer group"
            onClick={onSelectEmail}
          >
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center group-hover:bg-primary/20 transition-colors">
                <Mail className="w-6 h-6 text-primary" />
              </div>
              <div className="flex-1">
                <h3 className="font-semibold">Verificação por Email</h3>
                <p className="text-sm text-muted-foreground">
                  Receba o código no seu email
                </p>
              </div>
            </div>
          </Card>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.2 }}
        >
          <Card 
            className="p-4 hover:border-primary transition-all cursor-pointer group"
            onClick={onSelectSMS}
          >
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center group-hover:bg-primary/20 transition-colors">
                <Phone className="w-6 h-6 text-primary" />
              </div>
              <div className="flex-1">
                <h3 className="font-semibold">Verificação por SMS</h3>
                <p className="text-sm text-muted-foreground">
                  Receba o código via mensagem de texto
                </p>
              </div>
            </div>
          </Card>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.3 }}
        >
          <Card 
            className="p-4 hover:border-primary transition-all cursor-pointer group"
            onClick={onSelectWhatsApp}
          >
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 bg-[#25D366]/10 rounded-full flex items-center justify-center group-hover:bg-[#25D366]/20 transition-colors">
                <MessageCircle className="w-6 h-6 text-[#25D366]" />
              </div>
              <div className="flex-1">
                <h3 className="font-semibold">Verificação por WhatsApp</h3>
                <p className="text-sm text-muted-foreground">
                  Receba o código via WhatsApp Business
                </p>
              </div>
            </div>
          </Card>
        </motion.div>
      </div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.4 }}
        className="text-center text-xs text-muted-foreground bg-muted/30 rounded-lg p-3"
      >
        <p>
          💡 <strong>Dica:</strong> Se não receber email, você pode usar SMS ou WhatsApp como alternativa
        </p>
      </motion.div>
    </div>
  );
};